var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-viewer"},[_c('div',{staticClass:"error-viewer__status"},[_vm._v(_vm._s(_vm.status))]),_c('div',{staticClass:"error-viewer__title"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }